import styled from 'styled-components'

export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`
